import {call, put} from "redux-saga/effects";
import {receiveAirportData} from "../actions/airportDataActions";
import {fetchAirportData} from "../api/airportDataApi";

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
export default function* getAirportData(action) {
  try {
    // do api call
    const data = yield call(fetchAirportData);
    yield put(receiveAirportData(data));
  } catch (e) {
    console.log(e);
  }
}


// WEBPACK FOOTER //
// ./src/sagas/airportSaga.js